import { GET_DEFAULT_CONSTRUCTOR } from '@/constants/constructor';
import PAGES, { PAGE_LIST } from '@/constants/pages';
import getCarFields from '@/features/cars/helpers/getCarFields';
import { ISettings } from '@/interfaces/settings.interfaces';
import mergeGrid from '@/utils/mergeGrid';

import { CarsParametersType } from '../types';

/**
 * Подготавливает параметры для запроса списка автомобилей.
 * @param parameters основные параметры запроса автомобиля (фильтры и т.п.)
 * @param config объект конфигурации приложения
 * @param page текущая страница ответа (пагинация)
 * @returns объект параметров запроса.
 */
const getCarsParameters = (
  parameters: CarsParametersType,
  config: ISettings,
  page: (typeof PAGE_LIST)[number] = PAGES.Cars,
): CarsParametersType => {
  const { constructor } = config;

  // Строим сетку блоков для страницы с списком автомобиля
  const constructorGrid = mergeGrid(GET_DEFAULT_CONSTRUCTOR()[page], constructor?.[page]);

  // Формируем конфиг полей автомобилей в разрезе блоков, для сопоставления
  // его с блоками, использующимися на странице.
  const fields = getCarFields(constructorGrid, config);

  return {
    ...parameters,
    options: {
      ...parameters.options,
      options: {
        ...parameters?.options?.options,
        fields,
      },
    },
  };
};

export default getCarsParameters;
